import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

// rootReducers;
import rootReducers from './rootReducers';
import competencyWebSocketMiddleware from '../middleware/competencyWebSocket.middleware';
import competencyFetchLockMiddleware from '../middleware/competencyFetchLock.middleware';

const store = createStore(
  rootReducers, 
  composeWithDevTools(applyMiddleware(thunk, competencyFetchLockMiddleware, competencyWebSocketMiddleware))
);

export default store;
